module.exports = __webpack_public_path__ + "static/media/tripticovirgencoromoto_2.bfebf13e.jpg";